import entities from '../../../../config/Entities'
import { HALApiService } from '../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'

export const productsServiceService = new CachedService(entities.Orderadmin_Products_Entity_Service, '/products/service', HALApiService, createItemsData)
